
import React, { createContext, useContext, ReactNode } from 'react';
import { CloudPremisePluginManager } from "../types";

interface Props {
    children: ReactNode,
    pluginManager: CloudPremisePluginManager
}

const PluginsContext = createContext(null);
const PluginProvider = (props: Props) => {
    const { children, pluginManager } = props;
    return (
        <PluginsContext.Provider value={pluginManager}>
            {children}
        </PluginsContext.Provider>
    )
};

const usePluginProvider = () => {
    const context = useContext(PluginsContext);
    return context;
};

export { PluginProvider, PluginsContext, usePluginProvider };